// extracted by mini-css-extract-plugin
export default {"Hero":"Hero_Hero__xWMIj","ImageRound":"Hero_ImageRound__Gh+E8","swing-in":"Hero_swing-in__iTObC"};